module.exports = __webpack_public_path__ + "static/media/popupClose.0d6e358a.svg";